/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Check_Out_NowInputs */

const en_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Awesome!`)
};

const ar_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدهش`)
};

const de_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toll`)
};

const es_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Buenísimo!`)
};

const fr_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Génial`)
};

const it_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fantastico!`)
};

const ja_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最高！`)
};

const ko_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대박!`)
};

const pt_br_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrível`)
};

const ru_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Супер`)
};

const th_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สุดยอด`)
};

const tr_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harika`)
};

const zh_cn_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了！`)
};

const zh_tw_btn_check_out_now = /** @type {(inputs: Btn_Check_Out_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`太棒了！`)
};

/**
* | output |
* | --- |
* | "Awesome!" |
*
* @param {Btn_Check_Out_NowInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_check_out_now = /** @type {((inputs?: Btn_Check_Out_NowInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Check_Out_NowInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_check_out_now(inputs)
	if (locale === "ar") return ar_btn_check_out_now(inputs)
	if (locale === "de") return de_btn_check_out_now(inputs)
	if (locale === "es") return es_btn_check_out_now(inputs)
	if (locale === "fr") return fr_btn_check_out_now(inputs)
	if (locale === "it") return it_btn_check_out_now(inputs)
	if (locale === "ja") return ja_btn_check_out_now(inputs)
	if (locale === "ko") return ko_btn_check_out_now(inputs)
	if (locale === "pt_br") return pt_br_btn_check_out_now(inputs)
	if (locale === "ru") return ru_btn_check_out_now(inputs)
	if (locale === "th") return th_btn_check_out_now(inputs)
	if (locale === "tr") return tr_btn_check_out_now(inputs)
	if (locale === "zh_cn") return zh_cn_btn_check_out_now(inputs)
	return zh_tw_btn_check_out_now(inputs)
});